// extracted by mini-css-extract-plugin
module.exports = {"cas":"index_cas_2B5Ba","mpi":"index_mpi_O0_Bd"};